import { render } from "./IconAddText.vue?vue&type=template&id=12b7c9d0"
import script from "./IconAddText.vue?vue&type=script&lang=js"
export * from "./IconAddText.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__